module.exports = __webpack_public_path__ + "static/media/studentNeedsMoneySchool.090e10d8.png";